import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAreaChartRegular = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11.5995 6.95869L3.75 12.393V25.25H28.25V7.71299L21.1812 14.238C20.7024 14.68 19.9643 14.68 19.4855 14.238L11.5995 6.95869ZM10.9104 5.61138C11.3916 5.27821 12.0396 5.3236 12.4697 5.72062L20.3333 12.9793L27.6521 6.22349C28.4529 5.48437 29.75 6.05229 29.75 7.14199V25.5C29.75 26.1904 29.1904 26.75 28.5 26.75H3.5C2.80965 26.75 2.25 26.1904 2.25 25.5V12.262C2.25 11.8518 2.45124 11.4677 2.78849 11.2342L10.9104 5.61138Z",
		fill: "currentColor"
	})
});
export default SvgAreaChartRegular;
